import Filter from '../Filter';
import { getPaginatedEventOrganizers } from '../../api/user/EventOrganizerApi';

export default class EventOrganizerFilter extends Filter {
  constructor(data) {
    super(data);

    // Search by name
    this.name = data?.name ?? '';

    // Default limit
    this.limit = data?.limit ?? 50;
  }

  get key() {
    return 'event_organizers';
  }

  get paginatedFetcher() {
    return async () => await getPaginatedEventOrganizers(this);
  }
}
